import React from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"
import classNames from "classnames"

const propTypes = {
    // from app/static/frontend/search-new/containers/BulkActions/buttons/BulkActionsButtons
    bulkActionsCount: PropTypes.number,
    currentCount: PropTypes.number,
    isCountLoading: PropTypes.bool,
    selectButtonLabel: PropTypes.string,
    // from shared/search/searchify/bulkactions/action-creators
    bulkActionsSelectAll: PropTypes.func.isRequired,
    clearBulkActionsSelections: PropTypes.func.isRequired,
    // from app/static/frontend/search-new/components/BulkActions/BulkActionsConsole
    uniqueFlvId: PropTypes.string.isRequired,
}

// clear
export const BulkActionsSelectButton = (props) => (
    <Button
        className={classNames(`bulk-actions-console-button bulk-actions-console-button-clear`, {
            disabled: (!props.currentCount && !props.bulkActionsCount) || props.isCountLoading,
        })}
        data-cy="bulk-actions-console-button-clear"
        onClick={() => {
            // if we have selected anything already, clear it
            if (props.bulkActionsCount) {
                props.clearBulkActionsSelections(props.uniqueFlvId)
                // if not, select all inlines
            } else {
                props.bulkActionsSelectAll(props.uniqueFlvId, props.currentCount)
            }
        }}
    >
        {props.selectButtonLabel}
    </Button>
)
BulkActionsSelectButton.propTypes = propTypes

export default BulkActionsSelectButton
